import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { resetIcon } from '../../../../../core/shared/icons/side-panel/reset-icon';
import { CustomIconDirective } from '../../../../../cross-team-shared/icons/custom-icon.directive';

@Component({
  selector: 'h3-settings-header',
  templateUrl: './settings-header.component.html',
  styleUrl: './settings-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, CustomIconDirective],
})
export class SettingsHeaderComponent {
  @Input({ required: true }) value!: string;
  @Input({ required: true }) label!: string;
  @Output() resetValue = new EventEmitter<void>();

  protected readonly resetIcon = resetIcon;
}
